// Copyright (c) 2021 Deere & Company

import t from 'tcomb';

const UserDealerMappedResponse = t.struct({
    userId: t.String,
    dealerAccount: t.String,
    selected: t.Boolean,
    registrationAllowed: t.Boolean,
    delearCity: t.String,
    delearState: t.String,
    delearCountry: t.String,
    createdAt: t.maybe(t.Number),
}, {
    name: 'UserDealerMappedResponse',
    strict: false,
});

export const getDefaultState = () => new UserDealerMappedResponse({
    userId: '',
    dealerAccount: '',
    selected: false,
    registrationAllowed: false,
    delearCity: '',
    delearState: '',
    delearCountry: '',
    createdAt: null,

});

export default UserDealerMappedResponse;
